export default "__VITE_ASSET__BIAsHrm4__"